import {StatisticsSeriesItem} from './StatisticsSeriesItem';

export class StatisticsRecord {
  name: string;
  series: StatisticsSeriesItem[];
}
